import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChangePasswordPage from './components/ChangePasswordPage';
import { forgotPassword } from './redux/slice';
import { message } from 'antd';
import { history } from 'app/history';

const ChangePassword = () => {
  const { loading } = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const onSubmit = (payload) => {
    dispatch(forgotPassword(payload)).then((response) => {
      if (response?.payload?.success) {
        message.success(response?.payload?.message);
        history.push('/login');
      } else {
        message.error(response?.payload?.message);
      }
    });
  };

  return (
    <>
      <ChangePasswordPage loading={loading} onSubmit={onSubmit} />
    </>
  );
};

export default ChangePassword;
